export default {
  resend: 'Resend Code',
  resendIn: 'Resend Code in ',
};
